<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/share-link.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        {{ i18nPrefix() + '.title' | translate }}
      </h2>
      <p class="parent-dialog__subtitle">
        {{ i18nPrefix() + '.subtitle' | translate }}
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="i18nPrefix() + '.close' | translate"
    (click)="discard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (errorMessage()) {
    <p class="invite-dialog__error" role="alert">{{ errorMessage() }}</p>
  }

  @if (isGenerating()) {
    <p class="invite-dialog__hint">{{ i18nPrefix() + '.generating' | translate }}</p>
  } @else if (invite()) {
    <div class="invite-dialog__qr-wrap">
      @if (invite()!.qrImageBase64) {
        <img
          class="invite-dialog__qr"
          [src]="invite()!.qrImageBase64"
          [alt]="i18nPrefix() + '.qrAlt' | translate"
        />
      }
    </div>
    <div class="invite-dialog__link-panel">
      <span class="invite-dialog__link-label">
        {{ i18nPrefix() + '.copyLink' | translate }}
      </span>
      <p class="invite-dialog__url">{{ invite()!.webUrl }}</p>
    </div>
    @if (infoMessage()) {
      <p class="invite-dialog__info" role="status">{{ infoMessage() }}</p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  <div class="parent-dialog__actions-end">
    <app-parent-button variant="ghost" [disabled]="!invite()" (clicked)="copyLink()">
      {{ i18nPrefix() + '.copyLink' | translate }}
    </app-parent-button>
    <app-parent-button variant="primary" [disabled]="!invite()" (clicked)="shareInvite()">
      {{ i18nPrefix() + '.share' | translate }}
    </app-parent-button>
  </div>
</mat-dialog-actions>
